import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { imageCropBaseUrl, getProp } from '../../utilities.js';
import './csmArticlePanorama.css';
import { SectionName } from '../csmSectionLink/csmSectionLink.js';

const CsmArticlePanorama = props => {
  let bgImage = null;
  const widgets = getProp(props.article, 'widgets', []);
  for (let widget of widgets) {
    if (widget.type === 'screenimage') {
      bgImage = `${imageCropBaseUrl(
        widget.dimensions.X,
        widget.dimensions.Y,
        widget.dimensions.W,
        widget.dimensions.H,
      )}/${widget.uri}`;
      break;
    }
  }

  let style = {};
  if (bgImage) {
    style = {
      backgroundImage: `url(${bgImage})`,
      marginTop: '21px',
    };
  }

  return (
    <div
      className={cx('bg-alt-light article-header', {
        'article-header-with-image': bgImage !== null,
      })}
      style={style}
    >
      <div className="shadow" />
      <div className="container">
        <div className="article-header-title">
          <h1>
            <SectionName>{props.article.name}</SectionName>
          </h1>
          {props.pills}
        </div>
      </div>
    </div>
  );
};

CsmArticlePanorama.defaultProps = {
  pills: [],
};

CsmArticlePanorama.propTypes = {
  article: PropTypes.object.isRequired,
  pills: PropTypes.array,
};

export default CsmArticlePanorama;



// WEBPACK FOOTER //
// ./src/ui/src/component/csmArticlePanorama/csmArticlePanorama.js